module.exports = __webpack_public_path__ + "static/media/altre-strutture-casette-noleggiocampi.34e8e80e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/extra/casetta/altre-strutture-casette-noleggiocampi.jpg
// module id = 649
// module chunks = 0